export const lightPalette = {
  mode: 'light',
  primary: {
    // Colors.greenMain
    main: '#5A9D7F',
    light: '#5AB685',
    dark: '#116350',
    contrastText: '#ffffff',
  },
  secondary: {
    // Accent: Colors.vitaminC
    main: '#FC9700',
    light: '#ffbd4d',
    dark: '#b26800',
    contrastText: '#0A0A0A',
  },
  red :{
    darkRed: "#A32028",
    red: "#DB282E",
    lightRed: "#FFE6E6",
  },
  success: { main: '#5A9D7F' }, // Colors.green
  warning: { main: '#e8dc05' }, // Colors.lightyellow
  error: { main: '#DB282E' }, // Colors.red
  info: { main: '#59E5FA' }, // Colors.cyan
  background: {
    default: '#F5F8FA', // Colors.lightBlue
    paper: '#FFFFFF', // Colors.white
  },
  text: {
    main: '#FFFFFF',
    primary: '#0A0A0A', // Colors.black
    secondary: '#6A707E', // Colors.nouveau
    disabled: 'rgba(10,10,10,0.38)',
  },
  divider: '#E5E5E5', // Colors.titaniumWhite
  action: {
    hover: 'rgba(10,10,10,0.06)',
    selected: 'rgba(0,102,179,0.16)',
    disabled: 'rgba(0,0,0,0.26)',
    disabledBackground: 'rgba(0,0,0,0.12)',
  },
  social: {
    fb: '#3b5998',
    insta: '#E1306C',
    person: '#5AB685',
    system: '#000000',
    dark: '#000000',
    light: '#000000',
  }
};

export const darkPalette = {
  mode: 'dark',
  primary: {
    main: '#5A9D7F',
    light: '#5AB685',
    dark: '#116350',
    contrastText: '#0b1220',
  },
  secondary: {
    main: '#ce93d8',
    light: '#f3e5f5',
    dark: '#ab47bc',
    contrastText: '#0b1220',
  },
  red :{
    darkRed: "#A32028",
    red: "#DB282E",
    lightRed: "#FFE6E6",
  },
  success: { main: '#81c784' },
  warning: { main: '#ffb74d' },
  error: { main: '#e57373' },
  info: { main: '#64b5f6' },
  background: {
    default: '#0d1117',
    paper: '#161b22',
  },
  text: {
    // Colors.white
    main: '#FFFFFF',
    primary: '#e6eaf2',
    secondary: '#b3bac8',
    disabled: 'rgba(230,234,242,0.38)',
  },
  divider: 'rgba(230,234,242,0.12)',
  action: {
    hover: 'rgba(230,234,242,0.08)',
    selected: 'rgba(144,202,249,0.16)',
    disabled: 'rgba(255,255,255,0.3)',
    disabledBackground: 'rgba(255,255,255,0.12)',
  },
  social: {
    fb: '#3b5998',
    insta: '#E1306C',
    person: '#5AB685',
    system: '#000000',
    dark: '#000000',
    light: '#000000',
  }
};


